/* eslint-disable */
export default {
  cancel: 'Abbrechen',
  confirm: 'Bestätigen',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
